<footer class="main-footer">
  <div class="container">
    <div class="row justify-content-between">
      <div class="col-md-2">
        <div class="d-flex footer-about">
          <div class="footer-logo">
            <img src="assets/images/ic_icon.png" alt="" />
          </div>
          <div class="about-lang d-block d-sm-none ">
            <p>
              Swadha is a pioneering dairy startup with its inhouse end-to-end technology platform connecting farmers, customers and delivery networks to revolutionize the dairy supply chain.
            </p>
          </div>
        </div>
        
        
      </div>
      <div class="col-md-7">
        <div class="footer-links">
          <div class="linklist">
            <h3>About</h3>
            <ul>
              <li ><a role="button" routerLink="/aboutus">About Us</a></li>
              <li ><a role="button" routerLink="/media">Swadha in News</a></li>
              
            </ul>
          </div>
          <div class="linklist">
            <h3>Products</h3>
            <ul>
             
              <!-- <li role="button"><a href="/products/Milk">Milk</a></li>
               
              <li role="button"><a href="/products/Ghee">Ghee</a></li>
<li role="button"><a href="/products/Paneer">Paneer</a></li>
<li role="button"><a href="/products/Khoya">Khoya</a></li> -->
<li><a href="/products/Milk">Milk</a></li>
               
<li><a href="/products/Ghee">Ghee</a></li>
<li><a href="/products/Paneer">Paneer</a></li>
<li><a href="/products/Khoya">Khoya</a></li>
 
            </ul>
          </div>
          <div class="linklist">
            <h3>Services</h3>
            <ul>
              <!-- <li role="button"><a routerLink="/franchise/milk-franchise-opportunity">Franchise</a></li>
              <li role="button"><a routerLink="/saas/dairy-management-software">SaaS</a></li> -->
              <li><a href="https://franchise.swadhaagri.com/" target="_blank">Franchise</a></li>
              <!-- <li><a routerLink="/saas/dairy-management-software">SaaS</a></li> -->
              <li><a href="/support/investors">Enquiry</a></li>
             </ul>
          </div>
          

          <div class="linklist">
            <h3>Support</h3>
            <ul>
              <li><a href="/support/contactus">Contact</a></li>
<li><a href="/support/career">Careers</a></li>
<li><a href="/support/write-review">Write Review</a></li>
<li><a href="/support/faqs">FAQs</a></li>


              <!-- <li role="button"><a href="/support/contactus">Contact</a></li>
<li role="button"><a href="/support/career">Careers</a></li>
<li role="button"><a href="/support/write-review">Write Review</a></li>
<li role="button"><a href="/support/faqs">FAQs</a></li> -->

              <!-- <li role="button" routerLink="/support/contactus"><a>Contact</a></li>
              <li  routerLink="/support/career" role="button"><a>Careers</a></li>
              <li routerLink="/support/write-review" role="button"><a>Write Review</a></li>
              <li role="button" routerLink="/support/faqs"><a>FAQs</a></li> -->
            </ul>
          </div>
        </div>
      </div>

      <div class="col-md-3">
        <div class="language">
          <label for="language-select" class="lang-control">Language:</label>
          <select id="language-select" class="form-select form-select-lg mb-3 lang-control">
            <option selected>English</option>
           
          </select>
        </div>
        <div class="about-lang d-none d-sm-block ">
          <p>
            Swadha is a pioneering dairy startup with its inhouse end-to-end technology platform connecting farmers, customers and delivery networks to revolutionize the dairy supply chain.
          </p>
        </div>
      </div>
    </div>
  </div>
</footer>
<div class="footer-bottom">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-md-4">
        <p>© 2023, Swadha Agri Pvt. Ltd.</p>
      </div>
      <div class="col-md-4">
        <ul class="d-flex justify-content-center">
          <li>
            <a routerLink="/support/terms-conditions">Terms & Licensing </a>
          </li>
          <li>
            <a routerLink="/support/privacy-policy">Privacy & Policy </a>
          </li>
        </ul>
      </div>
      <div class="col-md-4">
        <ul class="d-flex social justify-content-end">
          <li>
            <a href="https://www.facebook.com/SwadhaAgri/" target="_blank" aria-label="Visit SwadhaAgri Facebook Page"><fa-icon [icon]="fb"></fa-icon></a>
          </li>
          <li>
            <a href="https://twitter.com/i/flow/login?redirect_after_login=%2FSwadhaAgri" target="_blank" aria-label="Visit SwadhaAgri Xtwitter Page"><fa-icon [icon]="faXtwitter"></fa-icon></a>
          </li>
          <li>
            <a href="https://www.instagram.com/swadha_agri/?utm_medium=copy_link" aria-label="Visit SwadhaAgri insta Page"><fa-icon [icon]="insta" target="_blank"></fa-icon></a>
          </li>
          <li>
            <a href="" aria-label="Visit SwadhaAgri linkedin Page"><fa-icon [icon]="linkedin" target="_blank" ></fa-icon></a>
          </li>
          <li>
            <a href="https://api.whatsapp.com/send?phone=918882362920&text=" target="_blank" aria-label="Visit SwadhaAgri whatsapp Page"><fa-icon [icon]="whatsapp" target="_blank"></fa-icon></a>
           
          </li>
          <li><a href="https://www.youtube.com/channel/UCC-09pR91-VhqEfr8JzZfXA" aria-label="Visit SwadhaAgri youtube Page"><fa-icon [icon]="youtube" target="_blank"></fa-icon></a></li>
        </ul>
      </div>
    </div>
  </div>
</div>
